<div class="input-container">
  <input type="text" class="search-container" />
  <button class="print-btn">
    <fa-icon [icon]="faPrint" />
  </button>
</div>
